import { createLazyFileRoute } from '@tanstack/react-router';

import { DefaultLayout } from '@src/layout';
import { IndustryDetail } from '@src/pages/Industries';

export const Route = createLazyFileRoute('/industries/manufacturing')({
  component: ManufacturingIndustryPage,
});

function ManufacturingIndustryPage() {
  return (
    <DefaultLayout>
      <IndustryDetail industryId="manufacturing" />
    </DefaultLayout>
  );
}
